import FileSaver from 'file-saver'
import html2canvas from 'html2canvas'

import { IDashboardGraphWrapperContext } from './GraphWrappers'

export function getExportFilename() {
  return `export_${new Date().toISOString()}.png`
}

export async function exportReactChart2ToImg(reactChart: IDashboardGraphWrapperContext['reactChart']) {
  const fileName = getExportFilename()
  if (!reactChart.chartRef.current) {
    console.error('React Chart reference is empty')
    return
  }

  const currentChart = reactChart.chartRef.current
  const originalDisplay = currentChart.options.plugins.title.display

  // Little hack to display chart title only on export
  // We change the title display value to true and restore it to it's original value at the end
  currentChart.options.plugins.title.display = true
  currentChart.update()
  currentChart.draw()

  const mapCanvas = currentChart.canvas
  const merge = document.createElement('canvas')
  merge.width = mapCanvas.width
  merge.height = mapCanvas.height

  const context = merge.getContext('2d')

  if (!context) {
    console.error('Merged context is null')
    return
  }
  //Fill background with white colour
  context.fillStyle = 'white'
  context.fillRect(0, 0, merge.width, merge.height)

  // Draw graphs on canva
  context.globalAlpha = 1.0
  context.drawImage(mapCanvas, 0, 0)

  currentChart.options.plugins.title.display = originalDisplay
  currentChart.update()
  currentChart.draw()

  merge.toBlob((blob) => {
    if (blob) {
      FileSaver.saveAs(blob, fileName)
    }
  })
}

export async function exportDeckGLChartToImg(deckGL: IDashboardGraphWrapperContext['deckGL']) {
  const fileName = getExportFilename()

  if (!deckGL.mapGlRef.current || !deckGL.deckRef.current) {
    console.error('MapGL or DeckGl reference are empty')
    return
  }
  const mapGL = deckGL.mapGlRef.current.getMap()
  const deck = deckGL.deckRef.current.deck

  const mapboxCanvas = mapGL.getCanvas()
  deck.redraw(true)
  const deckglCanvas = deck.canvas

  const merge = document.createElement('canvas')
  merge.width = mapboxCanvas.width
  merge.height = mapboxCanvas.height

  const context = merge.getContext('2d')

  if (!context) {
    console.error('Merged context is null')
    return
  }

  //Fill background with white colour
  context.fillStyle = 'white'
  context.fillRect(0, 0, merge.width, merge.height)

  // Draw graphs on canva
  context.globalAlpha = 1.0
  context.drawImage(mapboxCanvas, 0, 0)
  context.drawImage(deckglCanvas, 0, 0)

  if (!!deckGL.mapLegendRef.current) {
    const legendCanvas = await html2canvas(deckGL.mapLegendRef.current, {
      height: mapboxCanvas.height,
      backgroundColor: null, // Tranparent background
    })
    context.drawImage(legendCanvas, 0, 0)
  }
  merge.toBlob((blob) => {
    if (blob) {
      FileSaver.saveAs(blob, fileName)
    }
  })
}
